import { StyledNavPanel } from '@/components/styles';
import { ActiveLink, Nav, ContactWidget } from '@/components';
import { useState, useEffect } from 'react';
import genLinkParams from '@/lib/generateLinkParams';
import Icon from '@/assets/icons';

export default function NavPanel({ menu }) {
  const [searchHref, searchAs] = genLinkParams({ type: 'search' });

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY;
      const pageStart = scrollPos < 50;

      if (pageStart && scrolled) {
        setScrolled(false);
      }
      if (!pageStart && !scrolled) {
        setScrolled(true);
      }
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  return (
    <StyledNavPanel scrolled={scrolled}>
      <StyledNavPanel.Container>
        <Nav menu={menu} />
        <StyledNavPanel.Buttons>
          <ContactWidget buttonAppearance={true} fixed={false} waSrc="nav" />
          <ActiveLink href={searchHref} as={searchAs}>
            <StyledNavPanel.Search>
              <Icon name="search" />
            </StyledNavPanel.Search>
          </ActiveLink>
        </StyledNavPanel.Buttons>
      </StyledNavPanel.Container>
    </StyledNavPanel>
  );
}
